const buildEmiTypes = {
  BUILD_EMI: "BUILD_EMI",
  BUILD_EMI_COMMIT: "BUILD_EMI_COMMIT",
  BUILD_EMI_ROLLBACK: "BUILD_EMI_ROLLBACK",
};

export default buildEmiTypes;
